import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Brakuje REACT_APP_SUPABASE_URL lub REACT_APP_SUPABASE_ANON_KEY. Skopiuj .env.example do .env.local i uzupełnij wartości."
  );
}

// Klucz anon/publishable jest bezpieczny w aplikacji klienckiej wyłącznie dlatego,
// że dostęp do danych wymuszają polityki RLS z migracji Supabase.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
